import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import * as S from './styles';


interface IProps {
    title?: string; 
    icon: IconDefinition;
    children?: React.ReactNode,
}

export class CardOptionItem extends React.Component<IProps> {
    render() {
        return (
            <S.OptionsItem>
                <FontAwesomeIcon icon={this.props.icon} className="text-xs text-gpas-100" />
                <div className="flex-wrap flex-shrink-0">
                    {this.props.children}
                </div>
            </S.OptionsItem>)
    }
}